/**
 * Unified approval risk — single source of truth for advisor + badge surfaces.
 * When access-request metadata is present, L3 memory must not contradict it.
 */

export type RiskLevel = 'low' | 'medium' | 'high' | 'critical';

export interface UnifiedApprovalRisk {
  riskLevel?: RiskLevel;
  similarApprovedCount?: number;
  source: 'access_request';
}

export function resolveUnifiedApprovalRisk(
  metadata: Record<string, unknown> | null | undefined,
): UnifiedApprovalRisk | null {
  if (!metadata) return null;
  const ar =
    (metadata.access_request as Record<string, unknown> | undefined) ?? metadata;
  const riskLevel = ar.risk_level as RiskLevel | undefined;
  const similarApprovedCount =
    typeof ar.similar_approved_count === 'number'
      ? (ar.similar_approved_count as number)
      : undefined;
  if (!riskLevel && similarApprovedCount === undefined) {
    return null;
  }
  return {
    riskLevel,
    similarApprovedCount,
    source: 'access_request',
  };
}

export function riskLevelToBadgeColor(
  level: RiskLevel | undefined,
): 'green' | 'yellow' | 'orange' | 'red' | 'gray' {
  switch (level) {
    case 'critical':
    case 'high':
      return 'red';
    case 'medium':
      return 'orange';
    case 'low':
      return 'green';
    default:
      return 'gray';
  }
}
